import { ref } from 'vue';
import { defineStore } from 'pinia';

/** Client相關資料 Store */
export const useClientStore = defineStore('ClientStore', () => {
    /** 清除資料 */
    const $reset = () => {
        routeInitState.value = false;
        isLogin.value = false;
        isMobile.value = false;
        isWebView.value = false;
        currentAlertId.value = '';
        confirmedAlertId.value = '';
    };

    /** 使用者確認重新流程 */
    const routeInitState = ref<boolean>(false);
    const isLogin = ref<boolean>(false);
    /** 絕對到期時間 ISO 8601 UTC 字串（ex: 2026-04-23T14:30:00.0000000Z） */
    const expiresAtUtc = ref<string | null>(null);
    const isMobile = ref<boolean>(false);
    const isWebView = ref<boolean>(false);
    const currentAlertId = ref<string>('');
    const confirmedAlertId = ref<string>('');

    /** App Route 是否開啟第一個request  */
    const setRouteInit = (_initState: boolean) => {
        routeInitState.value = _initState;
    };

    /** Set使用者是否登入 */
    const setLoginState = (_isLogin: boolean) => {
        isLogin.value = _isLogin;
    };

    /** Set使用者登入 絕對到期時間 */
    const setExpiresAtUtcState = (_expiresAtUtc: string | null) => {
        expiresAtUtc.value = _expiresAtUtc;
    };

    /** Set使用者是否登入 */
    const setIsMobileState = (_isMobile: boolean) => {
        isMobile.value = _isMobile;
    };

    /** Set使用者是否登入 */
    const setIsWebViewState = (_isWebView: boolean) => {
        isWebView.value = _isWebView;
    };

    /** Set 停止登入Id */
    const setCurrentAlertId = (_id: string) => {
        currentAlertId.value = _id;
    };

    /** Set 確認 停止登入Id */
    const setConfirmedAlertId = (_id: string) => {
        confirmedAlertId.value = _id;
    };

    return {
        $reset,
        routeInitState,
        setRouteInit,
        isLogin,
        setLoginState,
        expiresAtUtc,
        setExpiresAtUtcState,
        isMobile,
        setIsMobileState,
        isWebView,
        setIsWebViewState,
        currentAlertId,
        setCurrentAlertId,
        confirmedAlertId,
        setConfirmedAlertId
    };
});
